import service from '@/utils/request'
// 登录
export function loginApi(data) {
  return service.post(`login/pclogin`, data);
}
// logo图片
export function LogoApi(data) {
  return service.post(`login/config`, data);
}
// 溢出token
export function outtokenApi(data) {
  return service.post(`pcuser/loginout`, data);
}

// 获取验证码
export function getnumcodeApi(data) {
  return service.post(`login/yanzma`, data);
}